import React, {useState, useEffect, useCallback, useRef} from 'react';
// import {useStripe, useElements, CardElement} from '@stripe/react-stripe-js';
import toastr from 'toastr';
import { getCurrentUserId, getJwt } from '../../../services/authService';
import http from '../../../services/httpService';
import Input from '../../common/Input';

import { Collapse, Button, MenuItem } from "@blueprintjs/core";
import {Select} from "@blueprintjs/select";
import InputRegular from '../../common/InputRegular';
import ReactIntlTelInput from 'react-intl-tel-input-v2';

import countries from '../../common/countries';
import usStates from '../../common/usStates';
import VatCheckFailedModalNew from '../../modals/VatCheckFailedModalNew';

import CardSection from './CardSection';

import {CardComponent, CardNumber, CardExpiry, CardCVV} from '@chargebee/chargebee-js-react-wrapper';

export default function CardWithDetailsSetupForm(props) {
    let selectedCountryName = '';
    if(props.project && props.project.default_billing_details && props.project.default_billing_details.address && props.project.default_billing_details.address.country){
        countries.map(country=>country.code === props.project.default_billing_details.address.country ? selectedCountryName = country.name : '' );
    }
    if(!selectedCountryName && props.user && props.user.country_name){
        selectedCountryName = props.user.country_name;
    }

    const [name, setName] = useState(props.user && props.user.name ? props.user.name : '');
    const [company, setCompany] = useState(props.project && props.project.name ? props.project.name : '');
    const [address, setAddress] = useState(props.project && props.project.default_billing_details && props.project.default_billing_details.address.line1 ?
        props.project.default_billing_details.address.line1 : '');
    const [billingDetailsOpen, setBillingDetailsOpen] = useState(true);
    const [fieldsCheckActive, setFieldsCheckActive] = useState(false);
    const [phone, setPhone] = useState({
        iso2: (props.project && props.project.default_billing_details && props.project.default_billing_details.phone) || (props.user && props.user.phone) ? '' : 'us',
        dialCode: (props.project && props.project.default_billing_details && props.project.default_billing_details.phone) || (props.user && props.user.phone) ? '' : '1',
        phone: props.project && props.project.default_billing_details && props.project.default_billing_details.phone ?
            props.project.default_billing_details.phone : props.user && props.user.phone ? props.user.phone : ''
    });

    const [email, setEmail] = useState(props.project && props.project.default_billing_details && props.project.default_billing_details.email ?
        props.project.default_billing_details.email : props.user && props.user.email ? props.user.email : '')

    const [postalCode, setPostalCode] = useState(props.project && props.project.default_billing_details && props.project.default_billing_details.address.postal_code ?
        props.project.default_billing_details.address.postal_code : '');

    const [city, setCity] = useState(props.project && props.project.default_billing_details && props.project.default_billing_details.address.city ?
        props.project.default_billing_details.address.city : '');

    const [country, setCountry] = useState(props.project && props.project.default_billing_details && props.project.default_billing_details.address.country ?
        props.project.default_billing_details.address.country : props.user && props.user.country ? props.user.country : '');

    const [countryName, setCountryName] = useState(selectedCountryName || 'Select Country');

    const [usState, setUsState] = useState(props.project && props.project.default_billing_details && props.project.default_billing_details.address.state ?
        props.project.default_billing_details.address.state : 'Select State');

    const [vatNumber, setVatNumber] = useState(props.project && props.project.default_billing_details && props.project.default_billing_details.vat_number ?
        props.project.default_billing_details.vat_number : '');

    const [poNumber, setPoNumber] = useState(props.project && props.project.default_billing_details && props.project.default_billing_details.po_number ?
        props.project.default_billing_details.po_number : '');

    const [filteredCountries, setFilteredCountries] = useState(countries);
    const [filteredStates, setFilteredStates] = useState(usStates);
    const [errorsList, setErrorsList] = useState([]);
    const [proPlanSuccessModalActive, setProPlanSuccessModalActive] = useState(false);
    const [paymentErrorMessage,setPaymentErrorMessage] = useState('');

    const [loader, setLoader] = useState(false);
    const [vatCheckFailedModalIsOpen, setVatCheckFailedModalIsOpen] = useState(false);
    const [vatChecked, setVatChecked] = useState(false);
    const [continueAnyway, setContinueAnyway] = useState(false);
    const [vatCheckFailedData ,setVatCheckFailedData] = useState({})

    const [chargeBeeErrors, setChargeBeeErrors] = useState([]);
    const [chargeBeeErrorMessage, setChargeBeeErrorMessage] = useState([]);

    const [chargeBeeClasses, setChargeBeeClasses] = useState({
        focus: 'focus',
        invalid: 'invalid',
        empty: 'empty',
        complete: 'complete',
    });



    // const stripe = useStripe();
    // const elements = useElements();

    window.Chargebee.init({
        site: process.env.REACT_APP_ENVIRONMENT === 'DEV' ? "emitto-test" : "emitto",
        publishableKey: process.env.REACT_APP_CHARGEBEE
    })

    const CardRef = useRef(null);

    const handleUpdateBillingDetails = async (id) => {
        let paymentMethodId = await id;
        let user = await props.user;
        let projectId = await props.selectedSource ? props.selectedSource : localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';

        try {
            const resultUpdateBillingDetails = await http.post(
                'api/user/' + user.id + '/project/' + projectId + '/pm/' + paymentMethodId + '/update',
                {
                    "billing_details": {
                        "address": {
                            "city": city || "",
                            "country": country || "",
                            "line1": address || "",
                            "line2": null,
                            "postal_code": postalCode || "",
                            "state": usState
                        },
                        "email": email,
                        "phone": getFullPhoneNumber(phone) || "",
                        "company_name": company || "",
                        "billing_name": name || "",
                        "vat_number": vatNumber || "",
                        "po_number": poNumber || "",
                    }
                },
                {headers: {authorization: getJwt()}}
            )
        } catch(e) {
            toastr.error("Billing details update wasn't successful.");
        }
    }

    let onChange = (status) => {
        // console.log('onChange: ', status.error)
        if(status && status.error){
            // let errMessages = Object.values(errors).filter(message => !!message);
            setChargeBeeErrors({
                ...chargeBeeErrors,
                [status.field]: status.error || ''
            });
            setChargeBeeErrorMessage(status.error.message);
        }
    }

    let onReady = (el) => {
        el.focus();
    }

    const handleSubmit = async (event) => {
        // We don't want to let default form submission happen here,
        // which would refresh the page.
        event ? event.preventDefault() : console.log('');

        // if (!stripe || !elements) {
        //     // Stripe.js has not yet loaded.
        //     // Make sure to disable form submission until Stripe.js has loaded.
        //     return;
        // }

        await setFieldsCheckActive(true)
        let anyErrorActive = await false;
        await errorsList.map(error=>error ? anyErrorActive = true : '')
        // console.log('anyErrorActive: ', anyErrorActive, this.state.errorsList)
        let user = await props.user;
        let projectId = await props.selectedSource ? props.selectedSource : localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';

        // console.log('provera: ', vatNumber, country, shouldAddVat)
        setTimeout(async ()=> {
            if(!anyErrorActive && country && phone.phone && address && postalCode && city && isPhoneNumber() && ((usState && (usState !== 'Select State')) || (country !== 'US'))){
                // const stripeResult = await http.post('api/user/' + user.id + '/project/' + projectId + '/customers/create_setup_intent',{}, {headers: {authorization: getJwt()}});
                // // console.log('stripeResult: ', stripeResult)
                // if(stripeResult.data && stripeResult.data.client_secret){
                //     const client_secret = await stripeResult.data.client_secret;

                try {

                    let project = await user.sources.data.find(project => projectId.toString() === project.id.toString());
                    let smsPlatform = project ? project.platforms.find(plan => plan.platform === 'sms') : '';
                    let plan = smsPlatform ? smsPlatform.plan : '';
                    setLoader(true);
                    setPaymentErrorMessage('');


                        // console.log('client_secret: ', client_secret)
                    try {
                        // const result = await stripe.confirmCardSetup(client_secret, {
                        //     payment_method: {
                        //         card: elements.getElement(CardElement),
                        //         billing_details: {
                        //             name: name,
                        //         },
                        //     }
                        // });
                        let token = '';
                        if(CardRef) {
                            // Call tokenize method on card element
                            // CardRef.current.tokenize().then((data) => {
                            //     console.log('chargebee token', data.token)
                            //     token = data.token;
                            // }).catch(error=>{
                            //     // console.log('error: ', error)
                            //     setLoader(false);
                            //     toastr.error(error)
                            //     setPaymentErrorMessage(error)
                            // });
                            try{
                                let response = await CardRef.current.tokenize();
                                // console.log('chargebee token', response.token)
                                token = response.token;
                            }catch(error){
                                setLoader(false);
                                toastr.error('Check the card number',error?.message)
                                // setPaymentErrorMessage(error)
                            }
                        }
                        // console.log('token: ', token)

                        if(token){

                            // if(process.env.REACT_APP_ENVIRONMENT === 'DEV'){
                            //     alert(token)
                            // }

                            let hasDefaultPaymentMethod = await false;
                            // console.log('defaultPaymentMethodCheck 1: ', props.newProject, props.selectedSource, props.paymentMethods)
                            if(props.newProject && props.paymentMethods && props.paymentMethods.length){
                                await props.paymentMethods.map(method=>method.project_id === props.selectedSource ? hasDefaultPaymentMethod = true : '');
                                // console.log('defaultPaymentMethodCheck 2: ', hasDefaultPaymentMethod)
                            }


                            // update_payment_methods is used for adding first payment method to workspace
                            // console.log('Usao sam: ', props.newProject, projectId)
                            if(props.newProject && !hasDefaultPaymentMethod){
                                try {
                                    const resultInitialPaymentMethod = await http.post(
                                        'api/user/' + user.id + '/project/' + projectId + '/customers/update_payment_methods',
                                        {
                                            "cb_token": token
                                        }, {headers: {authorization: getJwt()}}
                                    );

                                    if(resultInitialPaymentMethod && resultInitialPaymentMethod.data && resultInitialPaymentMethod.data.error){
                                        toastr.error(resultInitialPaymentMethod.data.error)
                                        await setLoader(false);
                                    }else{
                                        await handleUpdateBillingDetails(resultInitialPaymentMethod.data.payment_method_default.id)
                                        let listOfEuAbbreviations = ['BE', 'BG', 'CZ', 'DK', 'DE', 'EE', 'IE', 'EL', 'ES', 'FR', 'GR', 'HR', 'IT', 'CY', 'LV',
                                            'LT', 'LU', 'HU', 'MT', 'NL', 'AT', 'PL', 'PT', 'RO', 'SI', 'SK', 'FI', 'SE'];
                                        let shouldAddVat = false;
                                        if(vatNumber && country){
                                            await listOfEuAbbreviations.map(countryId=>countryId === country ? shouldAddVat = true : '' );
                                        }
                                        // console.log('vat data: ', vatNumber, country, shouldAddVat)
                                        if(vatNumber && country && shouldAddVat){
                                            setLoader(true);
                                            try {
                                                const checkVatResult = await http.post('api/user/' + user.id + '/project/' + projectId + '/test_vat', {
                                                    "vat_number": vatNumber,
                                                    // "cb_token": token,
                                                    // "country_to_check": country
                                                }, { headers: { authorization: getJwt() } });
                                                if(checkVatResult.data.vat_details && checkVatResult.data.vat_details.valid){
                                                    await setVatChecked(true);
                                                    await handleUpdateBillingDetails(resultInitialPaymentMethod.data.payment_method_default.id)
                                                }else{
                                                    await setVatCheckFailedData({
                                                        vatNumber,
                                                        paymentMethodId: resultInitialPaymentMethod.data.payment_method_default.id,
                                                        vatCheckPaymentMethodId: token,
                                                        country
                                                    })
                                                    await setVatCheckFailedModalIsOpen(true);
                                                }
                                                setLoader(false);
                                            }catch(e){
                                                await props.updatePaymentMethods();
                                                await setVatCheckFailedData({
                                                    vatNumber,
                                                    paymentMethodId: resultInitialPaymentMethod.data.payment_method_default.id,
                                                    vatCheckPaymentMethodId: token,
                                                    country
                                                })
                                                await setLoader(false);
                                                await setVatCheckFailedModalIsOpen(true);
                                            }
                                        }else {
                                            await handleUpdateBillingDetails(resultInitialPaymentMethod.data.payment_method_default.id)
                                            await props.updatePaymentMethods();
                                            await props.handleClose();
                                            await props.updateUserFromServer();
                                        }
                                        setLoader(false);
                                    }

                                    /* This part needs to be uncommented and checked in which cases it breaks */

                                    // const details = props.billingDetails

                                } catch(e) {
                                    await props.updatePaymentMethods();
                                    setLoader(false);
                                    toastr.error("Setting initial payment method wasn't successful, please try again");
                                }
                            } else {
                                // add_new_payment_method is used for adding payment method to workspace when there is default payment method
                                try {
                                    const resultAddNewMethod = await http.post(
                                        'api/user/' + user.id + '/project/' + projectId + '/customers/add_new_payment_method',
                                        {
                                            "cb_token": token
                                        },
                                        {headers: {authorization: getJwt()}}
                                    );

                                    if(resultAddNewMethod && resultAddNewMethod.data && resultAddNewMethod.data.error){
                                        toastr.error(resultAddNewMethod.data.error);
                                        setLoader(false)
                                    }else{
                                        await handleUpdateBillingDetails(resultAddNewMethod.data.payment_method_new.id)
                                        toastr.success("Payment method is successfully added.");
                                        // console.log('resultUpdatePaymentMethod: ', resultAddNewMethod, resultAddNewMethod.data, resultAddNewMethod.data.payment_method)

                                        /* This part needs to be uncommented and checked in which cases it breaks */
                                        let listOfEuAbbreviations = ['BE', 'BG', 'CZ', 'DK', 'DE', 'EE', 'IE', 'EL', 'ES', 'FR', 'GR', 'HR', 'IT', 'CY', 'LV',
                                            'LT', 'LU', 'HU', 'MT', 'NL', 'AT', 'PL', 'PT', 'RO', 'SI', 'SK', 'FI', 'SE'];
                                        let shouldAddVat = false;
                                        if(vatNumber && country){
                                            await listOfEuAbbreviations.map(countryId=>countryId === country ? shouldAddVat = true : '' );
                                        }
                                        // console.log('vat data: ', vatNumber, country, shouldAddVat)
                                        if(vatNumber && country && shouldAddVat){
                                            setLoader(true);
                                            try {
                                                const checkVatResult = await http.post('api/user/' + user.id + '/project/' + projectId + '/test_vat', {
                                                    "vat_number": vatNumber,
                                                    // "cb_token": token,
                                                    // "country_to_check": country
                                                }, { headers: { authorization: getJwt() } });
                                                // console.log('checkVatResult: ', checkVatResult, checkVatResult.data);
                                                if(checkVatResult.data.vat_details && checkVatResult.data.vat_details.valid){
                                                    await setVatChecked(true);
                                                    await handleUpdateBillingDetails(resultAddNewMethod.data.payment_method_new.id)
                                                    await props.updatePaymentMethods();
                                                    await props.handleClose();
                                                    await props.updateUserFromServer();
                                                }else{
                                                    await setVatCheckFailedData({
                                                        vatNumber,
                                                        paymentMethodId: resultAddNewMethod.data.payment_method_new.id,
                                                        vatCheckPaymentMethodId: token,
                                                        country
                                                    })
                                                    await setVatCheckFailedModalIsOpen(true);
                                                }
                                                setLoader(false);

                                            }catch(e){
                                                await setVatCheckFailedData({
                                                    vatNumber,
                                                    paymentMethodId: resultAddNewMethod.data.payment_method_new.id,
                                                    vatCheckPaymentMethodId: token,
                                                    country
                                                })
                                                await setLoader(false);
                                                await setVatCheckFailedModalIsOpen(true);
                                            }
                                        } else {
                                            await handleUpdateBillingDetails(resultAddNewMethod.data.payment_method_new.id);
                                            await props.updatePaymentMethods();
                                            await props.handleClose();
                                            await props.updateUserFromServer();
                                        }

                                        setLoader(false);
                                    }
                                } catch(e) {
                                    setLoader(false);
                                    toastr.error("Setting default payment method wasn't successful, please try again");
                                }
                            }
                        }

                    } catch(e) {
                        setLoader(false);
                        toastr.error('Error: ', e.error.message)
                    }


                } catch(e) {
                    toastr.error("Payment setup intent wasn't created. Please check data and try again.")
                    setLoader(false);
                }
            }
        },500);
    };

    const inputProps = {
        placeholder: '+' + phone.dialCode + ' *********'
    };

    const intlTelOpts = {
        preferredCountries: [],
    };
    // const onReady = (instance, IntlTelInput) => console.log('');

    let filterItems = (q) => {
        function escapeRegExp(s) {
            return s.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
        }

        const words = q
        .split(/\s+/g)
        .map(s => s.trim())
        .filter(s => !!s);
        const hasTrailingSpace = q.endsWith(" ");
        const searchRegex = new RegExp(
            words
            .map((word, i) => {
                if (i + 1 === words.length && !hasTrailingSpace) {
                    // The last word - ok with the word being "startswith"-like
                    return `(?=.*\\b${escapeRegExp(word)})`;
                } else {
                    // Not the last word - expect the whole word exactly
                    return `(?=.*\\b${escapeRegExp(word)}\\b)`;
                }
            })
            .join("") + ".+",
            "gi"
        );
        //console.log('Words: ', words)
        let filteredArray = [];
        countries.filter(item => {
            let imamIme = searchRegex.test(item.name);
            // searchRegex.lastIndex = 0; is used because a JavaScript RegExp object is stateful.
            //
            // When the regex is global, if you call a method on the same regex object, it will start from the index past the end of the last match.
            //
            // When no more matches are found, the index is reset to 0 automatically.
            //
            // To reset it manually, set the lastIndex property.
            searchRegex.lastIndex = 0;
            return imamIme ? filteredArray.push(item) : null;
        });
        setFilteredCountries(filteredArray)
    };

    let filterStates = (q) => {
        function escapeRegExp(s) {
            return s.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
        }

        const words = q
        .split(/\s+/g)
        .map(s => s.trim())
        .filter(s => !!s);
        const hasTrailingSpace = q.endsWith(" ");
        const searchRegex = new RegExp(
            words
            .map((word, i) => {
                if (i + 1 === words.length && !hasTrailingSpace) {
                    // The last word - ok with the word being "startswith"-like
                    return `(?=.*\\b${escapeRegExp(word)})`;
                } else {
                    // Not the last word - expect the whole word exactly
                    return `(?=.*\\b${escapeRegExp(word)}\\b)`;
                }
            })
            .join("") + ".+",
            "gi"
        );
        // console.log('Words: ', words)
        let filteredArray = [];
        usStates.filter(item => {
            let imamIme = searchRegex.test(item.name);
            searchRegex.lastIndex = 0;
            return imamIme ? filteredArray.push(item) : null;
        });

        setFilteredStates( filteredArray );
    };

    let updateErrorsList = (error, id) => {
        let errors = errorsList;
        errors[parseInt(id) - 1] = error;
        setErrorsList(errors)
    }

    const getFullPhoneNumber = (phoneObject) =>{
        // console.log('getFullPhoneNumber: ', phoneObject)
        let phone = phoneObject.phone.toString();
        let dialCode = phoneObject.dialCode;

        if (phone.startsWith('00')){
            phone = phone.substring(2);
            phone = '+' + phone;
            return phone
        } else if (phone.startsWith('0')){
            phone = phone.substring(1);
            phone = '+' + dialCode + phone;
            return phone
        } else if (phone.startsWith('+')){
            return phone
        } else if(phone && (phone !== '+')) {
            phone = '+' + dialCode + phone;
            return phone
        } else {
            return ''
        }
    }

    let isPhoneNumber = () => {
        let phoneNumber = getFullPhoneNumber(phone);
        var regEx = /^[+-]?\d+$/;
        if (regEx.test(phoneNumber) && phoneNumber.length > 6) {
            return true
        } else {
            return false
        }
    }

    let handleContinueAnyWay = async () =>{
        // await setContinueAnyway(true);
        await setVatNumber('');
        await props.updatePaymentMethods();
        await props.handleClose();
        await props.updateUserFromServer();

        //For handleSubmit() to have initially vatNumber value of '', useEffect has to be used, it is tracking all the
        //changes on continueAyway and vatNumber so it doesn't run when vatNumber is changed but continueAnyway isn't
    }

    useEffect(()=>{
        if(continueAnyway && !vatNumber){
            handleUpdateBillingDetails(vatCheckFailedData.paymentMethodId)
            setContinueAnyway(false)
        }

    }, [continueAnyway, vatNumber])

    return (
        <form className='card-input-container'>
            <div style={{margin: '0 0 10px 0'}}>
                <InputRegular
                    id="1"
                    label1="Card Holder Name"
                    placeholder="John Doe"
                    type='text'
                    onChange={ value => setName(value)}
                    value={name}
                    required={true}
                    fieldsCheckActive={fieldsCheckActive}
                    updateErrorsList={updateErrorsList}
                    errorMessage="Card holder name can't be empty"
                />
            </div>
            <div className="ex2-fieldset">
                {/*<label className="ex2-field">*/}
                {/*    <span className="ex2-label">Name</span>*/}
                {/*    <input name="firstName" className={ this.state.firstName ? "ex2-input val" : "ex2-input"} type="text" placeholder="John Doe" value={this.state.firstName} onChange={this.handleChange} />*/}
                {/*</label>*/}
                {/*<label className="ex2-field">*/}
                {/*    <span className="ex2-label">Email</span>*/}
                {/*    <input name="email" className={ this.state.email ? "ex2-input val" : "ex2-input"} type="text" placeholder="john@comp.any" value={this.state.email} onChange={this.handleChange} />*/}
                {/*</label>*/}
                {/*<label className="ex2-field">*/}
                {/*    <span className="ex2-label">Phone</span>*/}
                {/*    <input name="phone" className={ this.state.phone ? "ex2-input val" : "ex2-input"} type="text" placeholder="+63 53242 32637" value={this.state.phone} onChange={this.handleChange} />*/}
                {/*</label>*/}

                <label className="ex2-field">
                    {/* Render card component in combined-mode */}
                    <CardComponent ref={CardRef} className="ex2-input fieldset field"
                                   // icon={cardIcon}
                                   styles={{
                                       base: {
                                       color: '#293A4A',
                                       fontWeight: '500',
                                       fontFamily: 'Lato,-apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, sans-serif',
                                       fontSize: '14px',
                                       fontSmoothing: 'antialiased',
                                       iconColor: '#293A4A',

                                       ':focus': {
                                       // color: '#424770',
                                   },

                                       '::placeholder': {
                                       color: '#abacbe',
                                   },

                                       ':focus::placeholder': {
                                       color: '#abacbe',
                                   },
                                   },
                                       invalid: {
                                       color: '#E94745',

                                       ':focus': {
                                       color: '#e44d5f',
                                   },
                                       '::placeholder': {
                                       color: '#FFCCA5',
                                   },
                                   },
                                   }}
                                   // classes={classes}
                    />
                </label>
            </div>

            {/*<div className="fieldset">*/}
            {/*    <CardComponent className="field"*/}
            {/*        // fonts={fonts}*/}
            {/*        classes={{*/}
            {/*            'focus': 'focus-css-class',*/}
            {/*            'complete': 'complete-css-class',*/}
            {/*            'invalid': 'invalid-css-class',*/}
            {/*            'empty': 'empty-css-class',*/}
            {/*        }}*/}
            {/*        // locale={locale}*/}
            {/*        styles={{*/}
            {/*            base: {*/}
            {/*                // color: '#fff',*/}
            {/*                fontWeight: 600,*/}
            {/*                fontFamily: 'Quicksand, Open Sans, Segoe UI, sans-serif',*/}
            {/*                fontSize: '14px',*/}
            {/*                fontSmoothing: 'antialiased',*/}

            {/*                ':focus': {*/}
            {/*                    color: '#424770',*/}
            {/*                },*/}

            {/*                '::placeholder': {*/}
            {/*                    color: '#9BACC8',*/}
            {/*                },*/}

            {/*                ':focus::placeholder': {*/}
            {/*                    color: '#CFD7DF',*/}
            {/*                },*/}
            {/*            },*/}
            {/*            invalid: {*/}
            {/*                color: '#fff',*/}
            {/*                ':focus': {*/}
            {/*                color: '#FA755A',*/}
            {/*            },*/}
            {/*            '::placeholder': {*/}
            {/*                color: '#FFCCA5',*/}
            {/*            },*/}

            {/*        }}}*/}
            {/*       ref={CardRef}*/}
            {/*       onReady={onReady}*/}
            {/*    >*/}
            {/*        <CardNumber*/}
            {/*            placeholder='4111 1111 1111 1111'*/}
            {/*            className="field empty"*/}
            {/*            onChange={onChange}*/}

            {/*        />*/}
            {/*        <CardExpiry placeholder='MM / YY' className="field empty" onChange={onChange} />*/}
            {/*        <CardCVV placeholder='CVV' className="field empty" onChange={onChange} />*/}
            {/*    </CardComponent>*/}
            {/*</div>*/}

            {/*<div id="errors">{chargeBeeErrorMessage}</div>*/}

            {/*<CardSection />*/}

            <div className='billing-details-container'>
                <h3>Billing Details</h3>
                <p onClick={()=> {
                    setBillingDetailsOpen(!billingDetailsOpen)
                    props.passBillingDetailsOpen(!billingDetailsOpen)
                }}>
                    {billingDetailsOpen ? 'Collapse ' : 'Add Billing Details '}
                    <i className={billingDetailsOpen ? 'fas fa-caret-up' : 'fas fa-caret-down'}/>
                </p>
            </div>
            <Collapse isOpen={billingDetailsOpen} keepChildrenMounted={true}>
                <div className='full-width-input'>
                    <InputRegular
                        id="1"
                        label1="Company Name"
                        placeholder=""
                        type='text'
                        onChange={ value => setCompany(value) }
                        value={company}
                        required={true}
                        fieldsCheckActive={fieldsCheckActive}
                        updateErrorsList={updateErrorsList}
                        errorMessage="This field is required"
                    />
                </div>
                <div className='full-width-input'>
                    <InputRegular
                        id="2"
                        label1="Billing Name"
                        placeholder=""
                        type='text'
                        required={true}
                        onChange={ value => setName(value) }
                        value={name}
                        fieldsCheckActive={fieldsCheckActive}
                        updateErrorsList={updateErrorsList}
                        errorMessage="This field is required"
                    />
                </div>
                <div className='full-width-input'>
                    <InputRegular
                        id="4"
                        label1="Email"
                        placeholder=""
                        type='email'
                        // required={true}
                        onChange={ value => setEmail(value) }
                        value={email}
                        fieldsCheckActive={fieldsCheckActive}
                        //updateErrorsList={updateErrorsList}
                        errorMessage="This field is required"
                    />
                </div>
                <div className='full-width-input'>
                    <p htmlFor="post-link" className='full-row-label'>Phone</p>
                    <ReactIntlTelInput
                        className={((phone.phone === '') || !isPhoneNumber() ) && fieldsCheckActive ? 'onboard-tel error' : phone.phone === '' ? '' : 'onboard-tel valid'}
                        inputProps={inputProps}
                        intlTelOpts={intlTelOpts}
                        value={phone}
                        onChange={(e) => setPhone(e)}
                        // onReady={onReady}
                    />
                    {
                        ((phone.phone === '') || !isPhoneNumber() ) && fieldsCheckActive ?
                            <div className="selector-error-label">Valid phone number is required</div>
                            :
                            <div className='selector-error-label'></div>
                    }
                </div>
                <div className='full-width-input'>
                    <InputRegular
                        id="3"
                        label1="Address"
                        placeholder=""
                        type='text'
                        required={true}
                        onChange={ value => setAddress(value) }
                        value={address}
                        fieldsCheckActive={fieldsCheckActive}
                        updateErrorsList={updateErrorsList}
                        errorMessage="This field is required"
                    />
                </div>
                <div className="flex-direction-row justify-content-space flex-direction-column-mobile">
                    <div className='half-width-input'>
                        <InputRegular
                            id="5"
                            label1="Postal Code"
                            placeholder=""
                            required={true}
                            type='text'
                            onChange={ value => setPostalCode(value) }
                            value={postalCode}
                            fieldsCheckActive={fieldsCheckActive}
                            updateErrorsList={updateErrorsList}
                            errorMessage="This field is required"
                        />
                    </div>
                    <div className='half-width-input'>
                        <InputRegular
                            id="6"
                            label1="City"
                            placeholder=""
                            required={true}
                            type='text'
                            onChange={ value => setCity(value) }
                            value={city}
                            fieldsCheckActive={fieldsCheckActive}
                            updateErrorsList={updateErrorsList}
                            errorMessage="This field is required"
                        />
                    </div>
                </div>
                <Select
                    items={filteredCountries}
                    itemRenderer={(item, index)=> <MenuItem
                        key={index}
                        onClick={() => {
                            setCountry(item.code)
                            setCountryName(item.name)
                        }}
                        text={item.name + ' ' + item.flag}
                    /> }
                    filterable={true}
                    onQueryChange={filterItems}
                    resetOnClose={true}
                >
                    <p style={{fontSize: 12, marginBottom: 0}}>Country</p>
                    <Button
                        className={countryName === 'Select Country' ? 'country-selector-empty' : 'country-selector'}
                        text={ countryName }
                        rightIcon="caret-down">
                    </Button>

                </Select>

                {country === 'US' ?
                    <div>
                        <Select
                            items={filteredStates}
                            itemRenderer={(item, index)=> <MenuItem
                                key={index}
                                onClick={() => {
                                    setUsState(item.abbreviation)
                                }}
                                text={item.name}
                            /> }
                            filterable={true}
                            onQueryChange={filterStates}
                            resetOnClose={true}
                        >
                            <p style={{fontSize: 12, marginBottom: 0}}>State</p>
                            <Button
                                className={((usState === 'Select State')|| !usState) && fieldsCheckActive ? 'country-selector-error' : usState === 'Select State' ? 'country-selector-empty' : 'country-selector'}
                                text={ usState || 'Select State' }
                                rightIcon="caret-down">
                            </Button>

                        </Select>
                        {
                            ((usState === 'Select State')|| !usState) && fieldsCheckActive ?
                                <div className="selector-error-label" style={{marginTop: 5}}>This field is required</div>
                                :
                                <div className='selector-error-label' style={{marginTop: 5}}></div>
                        }
                    </div>
                    :
                    ''
                }

                <div className="flex-direction-row justify-content-space flex-direction-column-mobile">
                    <div className='half-width-input'>
                        <InputRegular
                            id="7"
                            label1="VAT Number"
                            placeholder=""
                            // required={true}
                            type='text'
                            onChange={value => setVatNumber(value)}
                            value={vatNumber}
                            fieldsCheckActive={fieldsCheckActive}
                            //updateErrorsList={updateErrorsList}
                            errorMessage="This field is required"
                        />
                    </div>
                    <div className='half-width-input'>
                        <InputRegular
                            id="8"
                            label1="PO Number"
                            placeholder=""
                            // required={true}
                            type='number'
                            onChange={ value => setPoNumber(value) }
                            value={poNumber}
                            fieldsCheckActive={fieldsCheckActive}
                            //updateErrorsList={updateErrorsList}
                            errorMessage="This field is required"
                        />
                    </div>
                </div>
            </Collapse>
            {props.errorMessage || paymentErrorMessage ?
                <p className='red-text'>{props.errorMessage || paymentErrorMessage}</p>
                :
                ''
            }
            <div className='flex-end' style={{margin: '20px 0'}}>
                <button className="btn-lite" onClick={ props.dataFromNavigation ?
                    (e)=>{
                        e.preventDefault()
                        props.updateWithDataFromNavigation()
                        props.handleClose()
                    }
                    :
                    (e)=>{
                        e.preventDefault()
                        props.handleClose()
                    }} style={{marginRight: 10}}>Cancel</button>
                { loader ?
                    <button className='btn-action' disabled={true}>Save Card <i className='fa fa-spin fa-spinner'></i></button>
                    :
                    <button className='btn-action' onClick={handleSubmit}>Save Card</button>
                }
            </div>
            <VatCheckFailedModalNew
                showModal={vatCheckFailedModalIsOpen}
                handleClose={()=>setVatCheckFailedModalIsOpen(false)}
                handleCloseMainModal={props.handleClose}
                maxWidth={500}
                handleContinueAnyWay={handleContinueAnyWay}
                vatCheckFailedData={vatCheckFailedData}
                updatePaymentMethods={props.updatePaymentMethods}
                updateUserFromServer={props.updateUserFromServer}
                user={props.user}
                projectId={props.selectedSource ? props.selectedSource : localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : ''}
                billingDetails={
                    {
                        "address": {
                            "city": city || "",
                            "country": country || "",
                            "line1": address || "",
                            "line2": null,
                            "postal_code": postalCode || "",
                            "state": usState
                        },
                        "email": email,
                        "phone": getFullPhoneNumber(phone) || "",
                        "company_name": company || "",
                        "billing_name": name || "",
                        "vat_number": vatNumber || "",
                        "po_number": poNumber || "",
                    }
                }
            />
            {/*<ProPlanSuccessModal*/}
                {/*showModal={proPlanSuccessModalActive}*/}
                {/*handleClose={() =>{*/}
                    {/*setProPlanSuccessModalActive(false)*/}
                    {/*props.history.push('/subscription-confirmation');*/}
                {/*}}*/}
                {/*maxWidth={500}*/}
                {/*history={props.history}*/}
            {/*/>*/}
        </form>
    );
}